import {useEffect, useState} from 'react';
import {useGetProductInCart} from 'hooks/product/useGetProductInCart';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {setProductCounterCount} from 'modules/product-card/thunks';

export const useSetInitialCounterCount = () => {
    const [isInitialCountSet, setIsInitialCountSet] = useState(false);
    const dispatch = useAppDispatch();
    const productInCart = useGetProductInCart();

    useEffect(() => {
        if (isInitialCountSet || !productInCart) {
            return;
        }

        setIsInitialCountSet(true);
        dispatch(setProductCounterCount(productInCart.cartData?.quantity));
    }, [dispatch, isInitialCountSet, productInCart]);
};
